import { Analytics } from '@cobliteam/analytics';
import type { RiskRecognitionHighlight } from '@cobliteam/api-lib/src/dashboard/riskRecognitions/Types';
import { useState } from 'react';
import RiskFootageDialog from './RiskFootageDialog';
import RiskFootagePreview from './RiskFootagePreview';

interface RiskFootageProps {
  highlight: RiskRecognitionHighlight;
  /** Surface que renderiza (analytics). */
  surface: 'bell' | 'page' | 'toast';
  size?: 'sm' | 'md';
  className?: string;
}

/**
 * Footage do risco self-contained: thumbnail (de `/media`) + modal multi-clipe, com o mesmo comportamento
 * em todas as surfaces (sino, toast, página). Sem `media_ids` o thumbnail (RiskFootagePreview) retorna
 * `null`, então pode ser montado incondicionalmente. O modal só monta quando aberto (reseta a seleção).
 */
const RiskFootage = ({ highlight, surface, size, className }: RiskFootageProps) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    Analytics.track('AI - Risk Recognition Feed - Footage Opened', {
      ruleName: highlight.metadata?.rule_name,
      clipCount: highlight.metadata?.media_ids?.length ?? 0,
      surface,
    });
    setOpen(true);
  };

  return (
    <>
      <RiskFootagePreview highlight={highlight} size={size} className={className} onClick={handleOpen} />
      {open ? <RiskFootageDialog highlight={highlight} open={open} onOpenChange={setOpen} /> : null}
    </>
  );
};

export default RiskFootage;
